import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Servicespartner(props) {
  return (
    <div className="tekrevol_gray_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Solutions">
              <h2>Get Next-Gen Managed Cloud Services</h2>
            </div>
            <h5 className="strong">
              Why Choose Us for your Cloud Management needs?
            </h5>
            <p>
              With a team of professionals in cloud technologies, we provide
              customized solutions that precisely align with your business
              requirements. Our focus on cost efficiency ensures that your cloud
              infrastructure is optimized to minimize expenses while maximizing
              performance and scalability.
            </p>
            <p>
              As top cloud service providers, we handle intricate aspects of the
              cloud, including automation, maintenance, and innovation, allowing
              you to concentrate on expanding your business. If already
              leveraging a cloud-based platform, we can easily implement the
              agility, flexibility, and scalability of corporate IT.
            </p>
            <p>
              Through our cloud management platform, we help you develop a fresh
              perspective and adapt an organizational mindset for establishing
              critical business applications and meeting business objectives.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-lg-1 my-auto"
          >
            <StaticImage
              src="../../images/services/managed-clouds/why_choose.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={651}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Servicespartner;
